<div class="col-12 px-0">
  <div class="col-12 px-0">
    <label
      class="installment-options-title">{{this.textService.keyValueMapping('installementOptionsHeader', 'Taksit Seçenekleri', sdkInitTexts)}}</label>
  </div>
  <div class="col-12 px-0 radio-button-groups">
    <mat-radio-group
      aria-labelledby="example-radio-group-label"
      class="example-radio-group"
      (change)="onChange($event)"
      [(ngModel)]="installmentOption">
      <mat-radio-button class="example-radio-button" *ngFor="let installment of installmentOptions"
                        [value]="installment">
        {{installment.count == 1 ? this.textService.keyValueMapping('singleShotPaymentLabel', 'Tek çekim', sdkInitTexts) : installment.count + ' x ' + installment.installmentAmount}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
